import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formatDateTimeDDMMYYHHMM } from '@core/utils/utils'

export default function useWorkplacePendingActivationsList() {
  // Use toast
  const toast = useToast()

  const refInstitutionListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'institution_name', label: 'Instituição', sortable: true },
    { key: 'name', label: 'Unidade' },
    {
      key: 'created_at', label: 'Criado', formatter: value => formatDateTimeDDMMYYHHMM(value), sortable: false,
    },
    { key: 'actions', label: 'Ações', sortable: false },
  ]
  const perPage = ref(50)
  const totalWorkplaces = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100, 200, 300]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(false)
  const institutionFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refInstitutionListTable.value ? refInstitutionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalWorkplaces.value,
    }
  })

  const refetchData = () => {
    refInstitutionListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  const fetchItems = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value ? 'desc' : 'asc',
      institution: institutionFilter.value || '',
    }
    store
      .dispatch('app-reports/workplacePendingActivations', params)
      .then(response => {
        const { data, meta } = response.data
        callback(data)
        totalWorkplaces.value = meta.pagination.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao buscar',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchItems,
    tableColumns,
    perPage,
    currentPage,
    totalWorkplaces,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refInstitutionListTable,
    refetchData,
    institutionFilter,
  }
}
